<div class="d-flex flex-column align-items-center justify-content-center text-center py-5 my-5">
  <div class="mb-4">
    <i class="bi bi-calendar-event display-1 text-muted opacity-50"></i>
  </div>
  <h2 class="h3 fw-bold mb-2">Scheduled Maintenance</h2>
  <p class="text-muted mb-4 mw-400px">
    View and manage scheduled maintenance for your drones. This feature is coming soon.
  </p>
  <a routerLink="/maintenance" class="btn btn-outline-primary">
    <i class="bi bi-arrow-left me-2"></i>Back to Maintenance
  </a>
</div>
